var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-row quantity"},[_c('div',{staticClass:"font-15-999",on:{"click":function($event){return _vm.change(0)}}}),_vm._v(" "),_c('div',{staticClass:"font-15-333 b"},[_vm._v(_vm._s(_vm.val))]),_vm._v(" "),_c('div',{staticClass:"font-15-999",on:{"click":function($event){return _vm.change(1)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55ebb20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputNumber.vue
// module id = null
// module chunks = 